import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
//import { NotificationService } from '../notification.service';
//import { NotificationService } from '../notification/notification.service';
import { ResetFormService } from './reset-form.service';
import { NotificationService } from '../notification.service';
import { AlertmessageService } from '../shared/alertmessage.service';
import { AppService } from '../app.service';
//import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ResetFormService]
})
export class LoginComponent implements OnInit 
{
 loginUser:FormGroup;
 submitted:Boolean=false;
  constructor(public _formBuilder:FormBuilder,
              public _router:Router,
              public _authService:AuthService,
              public _notificationService:NotificationService,
              public _resetFormService: ResetFormService,
              public _alert:AlertmessageService,
              public _appService:AppService
              ) 
  {
    this.setForm();
  }

  ngOnInit() 
  {
  }
  login(user)
  {
    //console.log(user);
    this.submitted=true;
            if(this.loginUser.valid)
            {
              this._appService.setUserLoggedIn(true);
                this._authService.login(user)
                .subscribe(response => {
                   // console.log('login response', response);
                   //console.log(response);
                    if(response.result)
                    {
                      //  console.log("test");
                        //this._notificationService.showNotification({type:'success',message :response.msg});
                        this._authService.loggedIn = true;
                        console.log(this._authService)
                        
                            sessionStorage.setItem('TaskNumber',response.bankID);
                            this._authService.TaskNumber=sessionStorage.getItem('TaskNumber');
                            sessionStorage.setItem('LoginType',response.logintype);
                            this._authService.LoginType = sessionStorage.getItem('LoginType');
                            localStorage.setItem('UserName',response.UserName);
                            this._authService.UserName=localStorage.getItem('UserName'); 
                            sessionStorage.setItem('token',response.access_token);
                            this._authService.token = sessionStorage.getItem('token');
                            sessionStorage.setItem('BankName',response.bankName);
                            this._authService.BankName = sessionStorage.getItem('BankName');
                        
                        this.submitted=false;                      
                        // console.log( this._authService.token, response.access_token);
                         if(response.requirePasswordChange==true)
                         {
                             this._notificationService.showNotification({ type: 'success', message: 'Please reset your password' });
                             this._router.navigate(['/profile']);
                         }
                         else
                         {
                             this._notificationService.showNotification({ type: 'success', message: response.msg });
                            //  this._router.navigate(['/staffdashboard/forexsale']);
                            this._router.navigate(['/dashboard']);
                         }
                        
                    }
                    else
                    {                     
                      this._router.navigate(['/']);
                      this.loginUser.controls['TaskNumber'].setValue('');
                      this.loginUser.controls['Password'].setValue('');
                      this._alert.openConfirmationDialogLong(response['msg']);
                     // this._notificationService.showNotification({type:'error',message:response['msg']});
                    }
                },
                (error)=>
                {
                        this._notificationService.showNotification({type:'error',message:'server error'});
                });
            }
            else
            {
                console.log('login form error');
            } 

  }
  setForm()
  {
    this.loginUser=this._formBuilder.group({
      'TaskNumber':['',Validators.required],
      'Password':['',Validators.required],
    });
  }

}
